import * as Constants from './constants';

/**
 * The function is responsible to provide a value given a key from the state.searchT3 map.
 *
 * @param {object} state - state of the application
 * @param {string} searchKey - the key for the state map
 * @returns {boolean}
 */
export function getSearchT3StateValue(state, searchKey) {
  return state.searchT3.get(searchKey);
}

export function getSearchToken(state) {
  return state.searchT3.get(Constants.SearchKeys.SEARCH_TOKEN);
}

export function selectMainSearchTerm(state) {
  return state.searchT3.getIn(
    [Constants.SearchKeys.MAIN_SEARCH, Constants.SearchKeys.SEARCH_TERM],
    '',
  );
}
